import React, { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { observer } from "mobx-react-lite";

import {
  ActionsSection,
  ButtonsSection,
  DataSection,
  SubSection,
} from "../../../components/data-components/sections/DataSections";
import PageLayout from "../../_layout/PageLayout";
import EditButton from "../../../components/buttons/edit-button/EditButton";
import DisplayImage from "../../../components/data-components/DisplayImage";
import DisplayDateCreated from "../../../components/data-components/DisplayDateCreated";
import DisplayCreatedBy from "../../../components/data-components/DisplayCreatedBy";
import {
  DisplayFirstName,
  DisplayLastName,
  DisplayEmail,
  DisplayPhone,
  DisplayUserName,
} from "../../users/components/DataComponents";
import { DeleteAccountButton } from "../components/buttons/DeleteAccountButton";
import { ChangePassword } from "../../../components/data-components/ChangePassword";
import { HeaderProfile } from "../../../components/svg/svgImageList";
import { api } from "../../../services/api/ApiService";
import { CurrentUserProfileStorageModel } from "../../../services/user/CurrentUserProfileStorage";
import { MyAccountMenuItemsModel } from "../MyAccountMenuItems";

export default observer(() => {
  const history = useHistory();

  const [currentUserProfileStorage] = useState(() =>
    CurrentUserProfileStorageModel.create({}, { api })
  );

  const [myAccountMenuItems] = useState(() => MyAccountMenuItemsModel.create({}));

  const userHasImageUploaded = useMemo(
    () => currentUserProfileStorage.currentUser.image?.url,
    [currentUserProfileStorage.currentUser]
  );

  const imageUrl = useMemo(
    () => currentUserProfileStorage.currentUser.image?.url || "",
    [currentUserProfileStorage.currentUser]
  );

  const menuItems = {
    staticItems: myAccountMenuItems.getStaticItems(),
  };

  const goToEditMyAccount = () => {
    history.push(`/my-account/edit`);
  };

  return (
    <PageLayout
      titleKey="MyAccount.title"
      id="view-my-account-details"
      menuItems={menuItems}
      isLoading={currentUserProfileStorage.isLoading}
    >
      <ActionsSection>
        <ButtonsSection>
          <EditButton onClick={goToEditMyAccount} />
          <DeleteAccountButton />
        </ButtonsSection>
        <ButtonsSection>
          <ChangePassword />
        </ButtonsSection>
      </ActionsSection>
      <DataSection labelKey="ViewUser.details">
        <SubSection className="image">
          {userHasImageUploaded ? (
            <DisplayImage id="user-image" url={imageUrl} className="my-account" />
          ) : (
            <DisplayImage id="user-image" placeholderImage={HeaderProfile} />
          )}
        </SubSection>
        <SubSection>
          <DisplayFirstName name={currentUserProfileStorage.currentUser.firstName} />
          <DisplayLastName name={currentUserProfileStorage.currentUser.lastName} />
          <DisplayUserName
            userName={currentUserProfileStorage.currentUser.userName}
            supportTag={currentUserProfileStorage.currentUser.isSupportAccount}
          />
        </SubSection>

        <SubSection>
          <DisplayEmail email={currentUserProfileStorage.currentUser.email} />
          <DisplayPhone phone={currentUserProfileStorage.currentUser.phone} />
        </SubSection>

        <SubSection>
          <DisplayDateCreated date={currentUserProfileStorage.currentUser.registrationDate} />
          <DisplayCreatedBy createdBy={currentUserProfileStorage.currentUser.userName} />
        </SubSection>
      </DataSection>
    </PageLayout>
  );
});
